<div class="tiles" [style.grid-template-rows]="'repeat(' + rows + ', 1fr)'">
    @for (tile of items; track tile.label) {
        <div class="card border-0 shadow-sm">
            <div class="card-body d-flex align-items-center">
                <div class="d-flex align-items-center justify-content-center flex-shrink-0 me-3 rounded-circle {{ tile.bg }}" style="width: 48px; height: 48px;">
                    <i class="{{ tile.icon }} fs-5 {{ tile.color }}"></i>
                </div>
                <div>
                    <div class="fs-5">{{ tile.value | number:'1.0-2' }}</div>
                    <small class="text-body-secondary">{{ tile.label }}</small>
                </div>
            </div>
        </div>
    }
</div>
